import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Availability, AvailabilityDayItem } from "../../../models/Consultant";
import { useOrganisation } from "../../../networking/organisation.hooks";
import AppText from "../../Core/AppText/AppText";
import Flex from "../../Layout/Flex";
import WeeklyTimeBlock from "./WeeklyTimeBlock";
import { Tooltip } from "@chakra-ui/react";
import { getAmPm } from "../../../utils/date.time.utils";

interface WeeklyAvailabilityProps {
	availability?: Availability;
	hideWeekdays?: boolean;
	condensed?: boolean;
	margin?: string;
}

const WeeklyAvailability: React.FC<WeeklyAvailabilityProps> = ({
	availability,
	hideWeekdays,
	condensed,
	margin,
}) => {
	const { data: organisation } = useOrganisation();

	const { t } = useTranslation();

	const weeklyAvailabilityData: AvailabilityDayItem[] = [
		{
			key: "MONDAY",
			data: availability?.monday || [],
		},
		{
			key: "TUESDAY",
			data: availability?.tuesday || [],
		},
		{
			key: "WEDNESDAY",
			data: availability?.wednesday || [],
		},
		{
			key: "THURSDAY",
			data: availability?.thursday || [],
		},
		{
			key: "FRIDAY",
			data: availability?.friday || [],
		},
		{
			key: "SATURDAY",
			data: availability?.saturday || [],
		},
		{
			key: "SUNDAY",
			data: availability?.sunday || [],
		},
	];

	function getToolTipText(item: AvailabilityDayItem) {
		let text = "";
		item.data.forEach((day) => {
			if (text.length === 0) {
				text += `${t(item.key)} \n`;
			}
			text += `${getAmPm(day.start)} - ${getAmPm(day.end)}  \n`;
		});
		return text;
	}

	return (
		<Flex width="fit-content" margin={margin}>
			{weeklyAvailabilityData.map((item, index) => {
				return (
					<Flex key={index} direction="column">
						{!hideWeekdays && (
							<div className="text-[13px] mb-1.5 font-bold leading-tight text-muted-foreground">
								{t(item.key.substring(0, 2) as any)}
							</div>
						)}
						<Tooltip
							p={2}
							bg="#fff"
							color="#000"
							label={getToolTipText(item)}
							aria-label="A tooltip"
							borderRadius="md"
							boxShadow="lg"
							border="1px solid"
							borderColor="#D4D4D4"
							sx={{ whiteSpace: "pre-line", textAlign: "center" }}
						>
							<DayAvailability
								className={`${condensed ? "condensed" : ""} ${
									index === weeklyAvailabilityData.length - 1 ? "last-day" : ""
								}`}
							>
								{organisation?.availabilityShifts?.map((timeSlots, timeSlotsIndex) => (
									<WeeklyTimeBlock
										isAvailable={
											item.data.find((day) => day.start === timeSlots.start) ? true : false
										}
										key={timeSlotsIndex}
									/>
								))}
							</DayAvailability>
						</Tooltip>
					</Flex>
				);
			})}
		</Flex>
	);
};
export default WeeklyAvailability;

const DayAvailability = styled.div`
	display: flex;
	width: 32px;
	justify-content: space-between;
	margin-right: 0.5rem;

	&.condensed {
		width: 22px;
		margin-right: 5px;
	}

	&.last-day {
		margin-right: 0;
	}
`;
